import { connect } from 'react-redux';
import { 
    logout, 
    getLoginAuthoriseStatus, 
    isForbidden, 
    onRefreshForbidden, 
    isServerError 
} from './../reducers/account/login';
import { getUserId, getUserEmail, fetchGetUserData, isLoading } from './../reducers/account/userData';
import {getCurrentRole, getCurrentSubRole, getSubRoles} from './../reducers/account/role';
import App from './App';
import {getTranslation, loadingTranslation} from "../reducers/common/localization";
import {
    getOrgPermissions, fetchGetOrgBalance, loadingOrgForApp
} from '../reducers/organization/organization';

const mapStateToProps = state => {
    return {
        isAuthorised: getLoginAuthoriseStatus(state),
        role: getCurrentRole(state),
        subRole: getCurrentSubRole(state),
        userId: getUserId(state),
        userEmail: getUserEmail(state),
        translation: getTranslation(state),
        loadingTranslation: loadingTranslation(state),
        loadingUserData: isLoading(state),
        loadingOrganizationData: loadingOrgForApp(state),
        isForbidden: isForbidden(state),
        isServerError: isServerError(state),
        orgPermissions: getOrgPermissions(state),
        subRoles: getSubRoles(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLogOut: () => {
            dispatch(logout());
        },
        onRefreshForbidden: () => {
            dispatch(onRefreshForbidden());
        },
        onGetOrgBalance: () => {
            dispatch(fetchGetOrgBalance());
        },
        onSetUser: () => {
            dispatch(fetchGetUserData());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.container.js